import { IResponse } from '@work4all/data';

import {
  UseEntityRecordMatcherProps,
  UseEntityRecordMatcherReturn,
} from '../types';

import { normalizeSourceEntityRecordMatcherResponseData } from './normalize-source-entity-record-matcher-response-data';
import { TargetEntityRecordMatcherConfigs } from './types';

type Props<TData> = Pick<UseEntityRecordMatcherProps, 'sourceEntity'> & {
  config: TargetEntityRecordMatcherConfigs<TData>;
  response: IResponse<Record<string, unknown>>;
  skip: boolean;
};

type Return<TData> = UseEntityRecordMatcherReturn<TData>;

export const createEntityRecordMatcherResult = <TData>({
  sourceEntity,
  config,
  response,
  skip,
}: Props<TData>): Return<TData> => {
  if (skip) {
    return {
      data: {} as TData,
      sourceEntity,
      enabled: false,
      pending: false,
    };
  }

  const data = normalizeSourceEntityRecordMatcherResponseData<TData>({
    config,
    sourceEntity,
    data: response.data,
  });

  return {
    data,
    sourceEntity,
    enabled: true,
    pending: response.pending,
  };
};
